import download from 'downloadjs';
import moment from 'moment';

export const handleTargetValue = (event) => {
  const { target } = event;
  let value;
  let options;

  switch (target.type) {
    case 'select-multiple':
      ({ options } = target);
      value = [];
      for (let i = 0, l = options.length; i < l; i += 1) {
        if (options[i].selected) {
          value.push(options[i].value);
        }
      }
      break;
    case 'checkbox':
      value = target.checked;
      break;
    case 'number':
      value = target.value || 0;
      break;
    case 'radio':
    case 'select-one':
    case 'text':
    case 'textarea':
    default:
      ({ value } = target);
      break;
  }

  const { name } = target;

  return { name, value };
};

const getErrorMessage = (errors) => {
  let error = '<ul>';
  errors.forEach((item) => {
    error = `${error}  <li>  ${item} </li>`;
  });
  error = `${error}  </ul>`;
  return error;
};

export const isJsonString = (str) => {
  try {
    const parsedJSON = JSON.parse(str);
    if (!parsedJSON || typeof parsedJSON !== 'object') {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
};

const objFromArray = (array, idName, id) => {
  const object = array.filter((element) => element[idName] === id);

  if (object[0]) {
    return object[0];
  }
  return {};
};

/* Add gets params to a url */
export const addQueryStringsToUrl = (url, params) => {
  if (!params) return url;

  let concatenatorTouse = '?';
  let internalUrl = url;
  const entries = Object.entries(params);

  for (let i = 0; i < entries.length; i++) {
    const [ key, value ] = entries[i];
    if (key && value && value !== 'undefined') {
      internalUrl += `${concatenatorTouse}${key}=${value}`;
      concatenatorTouse = '&';
    }
  }

  return internalUrl;
};

/* Used for handling html5 datetime-local fields. */
export function formatSecondsAsIsoString(seconds) {
  return seconds && seconds > 0
    ? moment(seconds * 1000)
      .format()
      .substr(0, 19)
    : 0;
}

export default {
  handleTargetValue,
  getErrorMessage,
  isJsonString,
  objFromArray,
  addQueryStringsToUrl,
};

/**
 * To download the file
 * @param {Response} response from api call to download file.
 * @returns {Promise<Blob>}
 */
export async function downloadFile(response) {
  const contentType = response.headers.get('content-type')?.toLowerCase();
  const contentdisposition = response.headers.get('content-disposition');

  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(contentdisposition);
  const filename = matches[1].replace(/['"]/g, '');

  const blob = await response.blob();
  return download(blob, filename, contentType);
}

/**
 * To download the file from a file link
 * @param {Uri} fileLink of the file
 * @param {String} name of the file
 */
export const downloadFileWithLink = (fileLink, name) => {
  const link = document.createElement('a');
  link.setAttribute('download', name);
  link.href = fileLink;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

/**
 * To generate universally uniqueue identifier.
 * @returns UUID
 */
export const uuid = () =>
  // Reference - https://www.tutorialspoint.com/how-to-create-guid-uuid-in-javascript
  // eslint-disable-next-line implicit-arrow-linebreak
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
